import Modal from './Modal';

class VideoModal extends Modal {
  private videoContainer: HTMLElement;
  private iframe: HTMLIFrameElement | null = null;

  constructor(modal: HTMLElement) {
    super(modal, true, false);
    this.videoContainer = this.modal.querySelector(
      '.js-video-container'
    ) as HTMLElement;

    if (!this.videoContainer) {
      throw new Error('Video container not found');
    }
  }

  cbOnModalOpen(): void {
    const trigger = this.openBtn[0];
    const videoId = trigger.getAttribute('data-youtube');

    if (!videoId) {
      throw new Error('Video ID not found');
    }

    this.creatAndLoadIframe(videoId);
  }

  cbOnModalClose(): void {
    if (this.videoContainer && this.iframe) {
      this.videoContainer.removeChild(this.iframe);
      this.iframe = null;
    }
  }

  private creatAndLoadIframe(videoId: string): void {
    if (!this.videoContainer) {
      return;
    }

    this.iframe = document.createElement('iframe');
    this.iframe.setAttribute(
      'src',
      `https://www.youtube.com/embed/${videoId}?autoplay=1`
    );
    this.iframe.setAttribute('frameborder', '0');
    this.iframe.setAttribute('allowFullscreen', 'true');
    this.iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
    );

    this.videoContainer.innerHTML = '';
    this.videoContainer.appendChild(this.iframe);
  }
}

export default VideoModal;
